import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	HostBinding,
	Inject,
	OnDestroy,
	OnInit,
	Optional,
	ViewEncapsulation,
} from "@angular/core";
import {
	MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
	MatLegacyDialog as MatDialog,
} from "@angular/material/legacy-dialog";
import { Store } from "@ngrx/store";
import { GtmEventAction } from "@obg/gtm.types/adaptive";
import { AlertComponent, AlertOptions, MAT_CORE_CONFIG, MatCoreConfig } from "@obg/mat.ui.core";
import { GeofencingConfigService, GeofencingSelector } from "@obg/ngx.common";
import { TelemetryService, WindowRef, ignoreNil } from "@obg/ngx.global";
import { ComponentFactoryService } from "@obg/ngx.ui.core";
import { Subscription } from "rxjs";
import { tap } from "rxjs/operators";

import { GeofencingAlertItem } from "../../telemetry/ui-interaction-telemetry.model";
import { GEOLOCATION_DEFAULT_LOCATION_ID, GTM_GEOFENCING_ALERT_SUB_AREA } from "../geofencing-alert.const";

@Component({
	selector: "obg-geolocation-dialog",
	templateUrl: "./geolocation-dialog.component.html",
	styleUrls: ["./geolocation-dialog.component.scss"],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GeolocationDialogComponent extends AlertComponent implements OnInit, OnDestroy {
	argentineRedirectButtonVisibility$ = this.store.select(GeofencingSelector.isInvalidArgentinePosition);

	@HostBinding("class.obg-geolocation-dialog") cssHostGeolocationDialog = true;

	protected readonly contactSupport = GeofencingAlertItem.ContactSupport;
	protected readonly defaultNavigateToUrl = this.geofencingConfigService.getArgentinaNavigateToUrl(
		GEOLOCATION_DEFAULT_LOCATION_ID
	);

	private data$$: Subscription | undefined;
	private navigateToUrl = this.defaultNavigateToUrl;

	constructor(
		@Inject(MAT_DIALOG_DATA) data: AlertOptions,
		@Optional() @Inject(MAT_CORE_CONFIG) coreConfig: MatCoreConfig,
		factoryService: ComponentFactoryService,
		changeDetector: ChangeDetectorRef,
		dialog: MatDialog,
		store: Store,
		private geofencingConfigService: GeofencingConfigService,
		private windowRef: WindowRef,
		private telemetryService: TelemetryService
	) {
		super(data, coreConfig, factoryService, changeDetector, dialog, store);
	}

	ngOnInit(): void {
		this.data$$ = this.store
			.select(GeofencingSelector.locationId)
			.pipe(
				ignoreNil(),
				tap((locationId) => {
					const navigateToUrl = this.geofencingConfigService.getArgentinaNavigateToUrl(locationId);
					this.navigateToUrl = !navigateToUrl ? this.defaultNavigateToUrl : navigateToUrl;
				})
			)
			.subscribe(() => this.changeDetector.markForCheck());
	}

	ngOnDestroy() {
		this.data$$?.unsubscribe();
	}

	navigate() {
		this.track(GeofencingAlertItem.Redirect);
		this.windowRef.native.location.href = this.navigateToUrl;
	}

	track(itemClicked: string) {
		this.telemetryService.track({
			SubArea: GTM_GEOFENCING_ALERT_SUB_AREA,
			ItemClicked: itemClicked,
			event: GtmEventAction.LinkClick,
			GAEventName: "Clicks",
		});
	}
}
